import { apiClient } from '@/libs/axios';
import { mutationOptions } from '@tanstack/react-query';
import type { AxiosError } from 'axios';

export type DeleteRoleParams = {
  roleId: string;
};

export const deleteRole = async (payload: DeleteRoleParams): Promise<void> => {
  const url = `/role/${payload.roleId}`;

  return await apiClient.delete(url);
};

export function deleteRoleMutationOptions() {
  return mutationOptions<void, AxiosError, DeleteRoleParams>({
    mutationFn: deleteRole,
  });
}
